/** Shared by the generated SDK and raw browser/server public fetches.
 * Keep the literal NEXT_PUBLIC access: Next.js replaces it at build time.
 * Production env overrides must be switched and rebuilt after gateway acceptance.
 */
export function getAgentApiHost(): string {
  return (
    process.env.NEXT_PUBLIC_AGENT_API_HOST ||
    (process.env.NODE_ENV === "production" ? "https://api.storerouter.ai" : "http://localhost:8001")
  );
}
